var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGodtvfavouritehover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 489.6,
    height: 469.3,
    viewBox: "0 0 489.6 469.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.8,0c14.97,0,29.94,8.6,35.53,25.81l40.57,124.84h131.27c36.19,0,51.24,46.31,21.96,67.58l-106.2,77.16,40.57,124.84c11.18,34.42-28.21,63.04-57.49,41.77l-106.2-77.16-106.2,77.16c-29.28,21.27-68.67-7.35-57.49-41.77l40.56-124.84L15.47,218.24c-29.28-21.27-14.23-67.58,21.96-67.58h131.27l40.56-124.84C214.86,8.6,229.83,0,244.8,0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodtvfavouritehover);
export default __webpack_public_path__ + "static/media/godtvfavouritehover.80e515624cc71b5f6ccf9bb3e6aa07d3.svg";
export { ForwardRef as ReactComponent };